import { MissionStatus } from "@/lib/models/mission";

export const MissionResultMap: {
  [key in MissionStatus]: {
    badgeColor:
    | "primary"
    | "secondary"
    | "error"
    | "warning"
    | "info"
    | "success"
    | "default";
    color: string;
    content: string;
  };
} = {
  PLANNED: {
    badgeColor: "secondary",
    color: "secondary.main",
    content: "予定",
  },
  INPROGRESS: {
    badgeColor: "info",
    color: "info.main",
    content: "進行中",
  },
  INFLIGHT: {
    badgeColor: "info",
    color: "info.main",
    content: "開始",
  },
  SUCCESS: {
    badgeColor: "success",
    color: "success.main",
    content: "成功",
  },
  FAILED: {
    badgeColor: "error",
    color: "error.main",
    content: "失敗",
  },
  PARTIAL_FAILED: {
    badgeColor: "warning",
    color: "warning.main",
    content: "部分失敗",
  },
  FINISHED: {
    badgeColor: "primary",
    color: "primary.main",
    content: "終了",
  },
  UNKNOWN: {
    badgeColor: "default",
    color: "default",
    content: "不明",
  },
};
